import gql from 'graphql-tag';

import googleDriveSharedDrivesPageFragment from '../fragments/googleDriveSharedDrivesPageFragment';

export const queryGoogleDriveSharedDrivesPage = gql`
  query googleDriveSharedDrivesPage(
    $credentialID: DokkioID!
    $pageToken: String
  ) {
    googleDriveSharedDrivesPage(
      credentialID: $credentialID
      pageToken: $pageToken
    ) {
      ...googleDriveSharedDrivesPageFragment
    }
  }
  ${googleDriveSharedDrivesPageFragment}
`;

export default queryGoogleDriveSharedDrivesPage;
